import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CartList from "./CartList";
import useTokenCheck from "../../hooks/useTokenCheck";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CartContext from "../../context/cart/CartContext";
import CardContext from "../../context/card/CardContext";
import useEntityContext from "../../hooks/entity-context";
import NavigationContext from "../../context/navigation/NavigationContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "../layout/ActionMenu";
import { DELETE_CART_ITEM } from "../../context/types";
import "./Cart.css";
import usePageTitle from "../../hooks/usePageTitle";

const Cart = (props) => {
  const authContext = useContext(AuthContext);
  const cartContext = useContext(CartContext);
  const cardContext = useContext(CardContext);
  const alertContext = useContext(AlertContext);
  const { clearAlerts, setAlert } = alertContext;
  const { user, token } = authContext;
  const { loading, cart, loadItems, error } = cartContext;
  const { orderLoading, submitOrder } = cardContext;
  const [processing, updateEntity] = useEntityContext();
  const navigationContext = useContext(NavigationContext);
  const { cartAction } = navigationContext;
  const configContext = useContext(ConfigContext);
  const { getConfigValueByCode } = configContext;

  const history = useHistory();
  const [mode, setMode] = useState("Edit");
  // const [hasRecharge, setRechargeFlag] = useState(false);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Patron Cart",
  });

  const cartContainsPatronRecharge = () => {
    if (!user.sponsor && cart) {
      const cartItem = cart.cartItems.filter((item) => {
        console.log("CART ITEMS ", item.type);
        return item.type === "Recharge";
      });
      console.log("FILTERED CART ITEMS ", cartItem);
      return cartItem.length > 0;
    }
    return false;
  };

  useEffect(() => {
    if (!error) {
      loadItems({}, token);
    }
    if (!cartContainsPatronRecharge) {
      setMode("View");
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!cartContainsPatronRecharge) {
      setMode("View");
    }
    //eslint-disable-next-line
  }, [cart]);
  const { hasTokenExpired } = useTokenCheck();
  const addMoreCard = async () => {
    await hasTokenExpired();
    console.log("Add More");
    if (cartAction) history.push(`/${cartAction}/default`);
  };
  const onSubmit = async () => {
    await hasTokenExpired();
    if (user.sponsor) {
      setMode("View");
    } else {
      history.push("/patron-billing");
    }
  };
  const onSubmitOrder = async () => {
    await hasTokenExpired();
    clearAlerts();
    const isSubscription = cartContainsPatronRecharge;
    console.log("isSubscription", isSubscription);
    try {
      const res = await submitOrder({}, token, user, isSubscription);
      console.log("$Res:", res);
      if (res && res.status) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        if (res.status !== "ERROR") {
          history.push("/user-confirm-order");
        }
      }
    } catch (err) {
      console.log("$ERR:", err.message);
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const handleDelete = async (item) => {
    console.log("Delete:", item);
    await updateEntity(item, DELETE_CART_ITEM);
    if (!error) {
      loadItems({}, token);
    }
  };

  return (
    <Fragment>
      {(loading || processing || orderLoading) && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 className="patronHome__pageTitle">
          {" "}
          {mode === "Edit" ? "Cart" : "REVIEW AND ORDER"}
        </h1>
        <div className="cartContainer">
          {cart && cart.cartItems.length > 0 ? (
            <Fragment>
              <CartList
                cart={cart}
                enableAction={true}
                onDelete={handleDelete}
              />
              {mode === "Edit" && cartContainsPatronRecharge() ? (
                <div className="cartContainer__action" aria-live="assertive">
                  {cartAction && (
                    <input
                      aria-label="ADD MORE TO CART "
                      type="button"
                      value="ADD MORE TO CART"
                      className="btn btn-block btn-primary cartContainer__action__button"
                      onClick={addMoreCard}
                    />
                  )}
                  <input
                    aria-label="CHECKOUT "
                    type="submit"
                    value="CHECKOUT"
                    className="btn btn-block btn-primary"
                    onClick={onSubmit}
                  />
                </div>
              ) : (
                <div className="cartContainer__action" aria-live="assertive">
                  <input
                    aria-label="SUBMIT ORDER "
                    type="submit"
                    value="SUBMIT ORDER"
                    className="btn btn-block btn-primary"
                    onClick={onSubmitOrder}
                  />
                  {cartAction && (
                    <input
                      aria-label="ADD MORE TO CART "
                      type="button"
                      value="ADD MORE TO CART"
                      className="btn btn-block btn-primary cartContainer__action__button"
                      onClick={addMoreCard}
                    />
                  )}
                </div>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {!loading && (
                <div
                  className="patronHome__pageTitle__desc"
                  aria-live="assertive"
                >
                  Your Cart is Empty
                </div>
              )}
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Cart;
